export default {
  elements: {
    line: {
      tension: 0
    }
  },
  legend: {
    display: false,
  },
  layout: {
    padding: {
      left: 20,
      right: 30,
      top: 30,
      bottom: 90
    }
  },
  maintainAspectRatio: false,
  responsive: true,
  title: {
    display: false,
  },
  tooltips: {
    enabled: false,
  },
  scales: {
    xAxes: [{
      display: true,
      scaleLabel: {
        display: false,
      },
      ticks: {
        autoSkip: true,
        maxTicksLimit: 16,
        maxRotation: 270,
        minRotation: 270,
        padding: 80,
      }
    }],
    yAxes: [{
      display: true,
      scaleLabel: {
        display: false,
      },
    }]
  },
  animation: {}
}
